import { PYTHON_SERVICE_ENDPOINTS, PythonAPI } from '@buildwise/libs/services';

class PythonFilesAPI extends PythonAPI {
  public deletFiles(payload: { fileIdsList: string[]; companyId: string }) {
    return this.post(PYTHON_SERVICE_ENDPOINTS.DELETE_FILES, payload);
  }

  public getExternalFileUrlWithProxyAPI(uri: string) {
    return this.get(`${PYTHON_SERVICE_ENDPOINTS.DOWNLOAD_FILES_PROXY_API}?uri=${uri}`);
  }
}

const pythonFilesAPI = new PythonFilesAPI();
export default pythonFilesAPI;
